import { ChangeDetectorRef, Component, EventEmitter, Input, OnDestroy, OnInit, Output } from '@angular/core'
import { NgbModal } from '@ng-bootstrap/ng-bootstrap'
import { CartItemListComponent } from '@spartacus/cart/base/components'
import { ActiveCartFacade, MultiCartFacade, SelectiveCartFacade } from '@spartacus/cart/base/root'
import { GlobalMessageType, UserIdService } from '@spartacus/core'
import { Order } from '@spartacus/order/root'
import { Subscription } from 'rxjs'
import { finalize } from 'rxjs/operators'
import { ICustomOrderEntry } from '../../../../models/interface/order-entry.interface'
import { ICustomProduct } from '../../../../models/interface/product.interface'
import { CustomCartService } from '../../../../services/custom-cart.service'
import { OrderHistoryService } from '../../../../services/order-history.service'
import { ProductDetailsService } from '../../../../services/product.service'
import { CustomGlobalMessageService } from '../../../../services/shared/custom-global-message/custom-global-message.service'
import { ToastService } from '../../../../services/toast.service'
import { ConfirmModalComponent, DataConfirmModal } from '../../../shared/confirm-modal/confirm-modal.component'

@Component({
    selector: 'app-custom-cart-item-list',
    templateUrl: './custom-cart-item-list.component.html',
    styleUrls: ['./custom-cart-item-list.component.scss'],
    standalone: false
})
export class CustomCartItemListComponent extends CartItemListComponent implements OnInit, OnDestroy {
  //export class CustomCartItemListComponent implements OnInit, OnDestroy {
  constructor(
    protected userIdService: UserIdService,
    public orderHistoryService: OrderHistoryService,
    private modalService: NgbModal,
    public toastService: ToastService,
    private changeDetectorRef: ChangeDetectorRef,
    public globalMessageService: CustomGlobalMessageService,
    public customCartService: CustomCartService,
    public productDetailsService: ProductDetailsService,
    activeCartFacade: ActiveCartFacade,
    selectiveCartFacade: SelectiveCartFacade,
    multiCartFacade: MultiCartFacade
    // outletContextData: OutletContextData
  ) {
    super(activeCartFacade, selectiveCartFacade, userIdService, multiCartFacade, changeDetectorRef)
  }

  public cancelledItems: any = {}
  public orderCancelled?: boolean

  @Input() order: any
  @Input() showAllStatus?: boolean
  private subscriptions: Subscription = new Subscription()
  public validateQuantity?: boolean

  @Output() itemRemoved?: EventEmitter<boolean> = new EventEmitter()

  public setMaxQuantity(product: ICustomProduct): number {
    // if (product.stock && product.stock.stockLevel) {
    // AC-1740
    // return product.stock.stockLevel;
    return this.productDetailsService.maxQuantity
    // } else {
    //   return null;
    // }
  }

  public onItemRemoved(value?: any): void {
    this.itemRemoved.emit(value)
  }

  public setHasStock(product: ICustomProduct): boolean {
    if (product?.stock && product.stock.stockLevelStatus !== 'outOfStock') {
      return true
    } else {
      return false
    }
  }

  ngOnInit(): void {
    this.subscriptions.add(
      this.orderHistoryService.orderCancelled$.subscribe((order) => {
        this.cancelAllOrderItem(order)
        this.orderCancelled = true
        this.changeDetectorRef.detectChanges()
      })
    )
    this.subscriptions.add(
      this.customCartService.validateQuantity$.subscribe(() => {
        this.validateQuantity = true
      })
    )
  }

  ngOnDestroy(): void {
    this.subscriptions.unsubscribe()
  }

  public onCancelItem(order: any, item: ICustomOrderEntry): void {
    const dataModal: DataConfirmModal = {
      title: 'Cancel Item',
      msg: 'Are you sure you want to cancel the item?',
      extra: 'This operation can not be undone.',
      yes: 'Cancel Item'
    }

    const modalRef = this.modalService.open(ConfirmModalComponent, { centered: true })
    modalRef.componentInstance.data = dataModal
    modalRef.result.then(
      () => {
        this.cancelledItems[item.product.code] = {
          showSpinner: true,
          isCancelling: false
        }
        this.changeDetectorRef.detectChanges()

        this.orderHistoryService
          .cancelPartialOrder(order, item)
          .pipe(
            finalize(() => {
              this.cancelledItems[item.product.code].showSpinner = false
              this.changeDetectorRef.detectChanges()
            })
          )
          .subscribe(
            () => {
              this.cancelledItems[item.product.code].isCancelling = true
              this.globalMessageService.add('Item cancelled successfully.', GlobalMessageType.MSG_TYPE_CONFIRMATION)

              const localOrder = { ...order }
              this.markEntriesCancel(localOrder)
              this.orderHistoryService.itemCancelled(localOrder)
            },
            (err) => {
              this.globalMessageService.add(err.message, GlobalMessageType.MSG_TYPE_ERROR)
            }
          )
      },
      () => {}
    )
  }

  public showSpinnerOnItemCancel(item: ICustomOrderEntry): boolean {
    return this.cancelledItems[item.product.code]?.showSpinner
  }

  public checkCancellingStatusForItem(item: ICustomOrderEntry): boolean {
    return this.cancelledItems[item.product.code]?.isCancelling
  }

  public showCancelItem(order: Order, item: ICustomOrderEntry): boolean {
    if (this.orderCancelled || !this.orderHistoryService.checkStatusForFullCancellation(order?.status)) {
      return false
    }
    return (
      !this.itemCancelledLocally(item) &&
      this.orderHistoryService.checkStatusForPartialCancellation(item?.orderEntryStatusDisplay)
    )
  }

  private cancelAllOrderItem(order: Order): void {
    const entries = order?.entries as Array<ICustomOrderEntry>
    if (entries?.length) {
      for (const item of entries) {
        this.cancelledItems[item.product.code] = {
          showSpinner: false,
          isCancelling: true
        }
      }
    }
  }

  private itemCancelledLocally(item: ICustomOrderEntry): boolean {
    return this.cancelledItems[item?.product?.code]?.isCancelling
  }

  private markEntriesCancel(order: Order): void {
    order.entries = order.entries.map((entry: ICustomOrderEntry) => {
      if (this.cancelledItems[entry.product.code]?.isCancelling) {
        return { ...entry, orderEntryStatusDisplay: 'Cancelling' }
      }
      return entry
    })
  }
}
